/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var NotFound = (function (_Component) {
	_inherits(NotFound, _Component);

	function NotFound() {
		_classCallCheck(this, NotFound);

		_Component.apply(this, arguments);
	}

	NotFound.prototype.render = function render() {
		var styles = require('./NotFound.css');

		return _react2['default'].createElement(
			'section',
			{ className: styles.Base },
			_react2['default'].createElement(
				'article',
				{ className: styles.Content },
				_react2['default'].createElement(
					'h1',
					{ className: styles.Title },
					'Whoops!'
				),
				_react2['default'].createElement(
					'p',
					{ className: styles.P },
					'We couldn’t find that article!'
				),
				_react2['default'].createElement(
					'p',
					{ className: styles.P },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ to: '/' },
						'Go to Front Page'
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Search },
					_react2['default'].createElement(_components.SearchField, null)
				)
			)
		);
	};

	return NotFound;
})(_react.Component);

exports['default'] = NotFound;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NotFound/NotFound.js
 ** module id = 706
 ** module chunks = 0
 **/